import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000";

const API = axios.create({
  baseURL: API_BASE_URL
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
      // Importante: rechazar para que los `await API.get()` terminen (finally/catch)
      // y no queden pantallas en "Cargando…" forever.
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default API;